import { defineStyleConfig } from "@chakra-ui/react"

const Text = defineStyleConfig({
    baseStyle: {
        fontFamily: "'Lato'",
        marginBottom: 0
    },
})

export default Text